import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpotlightResponseFooterComponent } from '../shared/response-footer/response-footer.component';
import { SpotlightAvatarComponent } from '../shared/avatar/avatar.component';
import { isExcludedField, getProfileFieldLabel } from './result-member-profile.constants';
import { getMemberName, formatProfileValue } from './result-member-profile.mappers';

export interface ProfileField {
    key: string;
    label: string;
    value: any;
    formattedValue: string;
}

@Component({
    selector: 'spotlight-result-member-profile',
    standalone: true,
    imports: [
        CommonModule,
        SpotlightResponseFooterComponent,
        SpotlightAvatarComponent
    ],
    templateUrl: './result-member-profile.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightResultMemberProfileComponent {
    @Input() title: string = '';
    @Input() description: string = '';
    @Input() data: any = {};
    @Input() executionTimeMs: number = 0;

    getName(): string {
        return getMemberName(this.data);
    }

    getComplementaryFields(): ProfileField[] {
        if (!this.data) return [];

        return Object.keys(this.data)
            .filter(key => !isExcludedField(key))
            .map(key => ({
                key,
                label: getProfileFieldLabel(key),
                value: this.data[key],
                formattedValue: formatProfileValue(this.data[key], key)
            }));
    }
}
